import * as React from 'react';
import { usePage } from '@inertiajs/react';
import { assetUrl } from '../../utils/assetUrl';
import { route } from '../../utils/route';
import { trackSignupClicked } from '../../utils/tracking';

interface OngHeroProps {
  loginUrl: string;
  whatsappUrl: string;
}

export function OngHero({}: OngHeroProps) {
  const { cdnUrl } = usePage<{ cdnUrl: string }>().props;
  const heroImg = assetUrl(cdnUrl, '/img/ong-hero.webp');

  return (
    <section className="ong-hero">
      <style>{`
        .ong-hero {
          position: relative;
          background: url(${heroImg}) center center/cover no-repeat;
          padding: 100px 0 110px;
          min-height: 480px;
          display: flex;
          align-items: center;
        }
        .ong-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.62);
        }
        .ong-hero-inner {
          position: relative;
          z-index: 1;
          max-width: 800px;
          margin: 0 auto;
          padding: 0 24px;
          text-align: center;
        }
        .ong-hero h1 {
          font-size: 38px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 16px;
          line-height: 1.2;
        }
        .ong-hero .hero-sub {
          font-size: 20px;
          color: rgba(255,255,255,0.9);
          margin: 0 0 12px;
          font-weight: 500;
        }
        .ong-hero .hero-desc {
          font-size: 17px;
          color: rgba(255,255,255,0.75);
          margin: 0 0 36px;
        }
        .ong-hero-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .ong-btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: #1EAA25;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border-radius: 8px;
          text-decoration: none;
          transition: background 0.2s;
        }
        .ong-btn-primary:hover {
          background: #178f1e;
          color: #fff;
          text-decoration: none;
        }
        .ong-btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: transparent;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border: 2px solid rgba(255,255,255,0.6);
          border-radius: 8px;
          text-decoration: none;
          transition: all 0.2s;
        }
        .ong-btn-secondary:hover {
          background: rgba(255,255,255,0.1);
          border-color: #fff;
          color: #fff;
          text-decoration: none;
        }
        @media (max-width: 640px) {
          .ong-hero {
            padding: 70px 0 80px;
            min-height: auto;
          }
          .ong-hero h1 {
            font-size: 28px;
          }
          .ong-hero .hero-sub {
            font-size: 17px;
          }
          .ong-hero-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .ong-btn-primary, .ong-btn-secondary {
            justify-content: center;
          }
        }
      `}</style>
      <div className="ong-hero-inner">
        <h1>Frutas y verduras frescas para tu organización social</h1>
        <p className="hero-sub">Alimentar con calidad es parte de la misión.</p>
        <p className="hero-desc">Abastecemos comedores comunitarios, hogares, fundaciones y organizaciones sociales en Córdoba.</p>
        <div className="ong-hero-ctas">
          <a href={route('wholesale.pricing')} className="ong-btn-primary">
            <i className="fa fa-list-alt" /> Ver Precios Mayoristas
          </a>
          <a href={route('company.create')} className="ong-btn-secondary" onClick={() => trackSignupClicked('organizaciones-sociales', 'hero')}>
            <i className="fa fa-user-plus" /> Crear una cuenta
          </a>
        </div>
      </div>
    </section>
  );
}
